import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {HgImportStatusInternalEnum} from '../../../../../model/dto/enum/hg-import-status-internal.enum';

/**
 * Shared error-display component for the HgImport OBC.
 *
 * Renders a red error box containing the import's errorMessage, but only when
 * the status is ERROR. In all other cases the component renders nothing.
 */
@Component({
    selector: 'hg-import-error-display',
    templateUrl: './hg-import-error-display.component.html',
    standalone: false
})
export class HgImportErrorDisplayComponent implements OnInit, OnChanges {

    @Input() errorMessage: string;
    @Input() status: HgImportStatusInternalEnum | string;

    initialized: boolean = false;

    protected readonly HgImportStatusInternalEnum = HgImportStatusInternalEnum;

    ngOnInit(): void {
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

    /**
     * Returns true when the import's status is ERROR. Accepts both the enum
     * value (number) and the string 'ERROR' to stay lenient across call sites.
     */
    get isError(): boolean {
        return this.status === HgImportStatusInternalEnum.ERROR || this.status === 'ERROR';
    }
}
